export const IconCardBack = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        d="M3.315 4.348h17.363c1.263 0 2.42 1.078 2.315 2.37v10.563c0 1.293-1.052 2.371-2.315 2.371H3.315C2.052 19.652 1 18.574 1 17.281V6.719c0-1.293 1.052-2.371 2.315-2.371m17.363 13.58c.421 0 .737-.324.737-.647v-5.604H2.578v5.604c0 .323.316.647.737.647zM2.684 7.797h18.73V6.719c0-.323-.315-.647-.736-.647H3.315c-.42 0-.737.324-.737.647v1.078zm17.152 9.16h-4.104c-.315 0-.526-.323-.526-.646v-2.802c0-.324.21-.54.526-.54h4.104c.316 0 .527.216.527.54v2.91c0 .323-.211.539-.527.539m-.526-2.91H16.26v1.725h3.051z"
        clipRule="evenodd"
      />
    </svg>
  );
};
